var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActionControl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.771 6.81266L0.0834961 10.5002L3.771 14.1877L5.60433 12.3439L3.771 10.5002L5.60433 8.65641L3.771 6.81266ZM10.5002 17.2293L8.65641 15.396L6.81266 17.2293L10.5002 20.9168L14.1877 17.2293L12.3439 15.396L10.5002 17.2293ZM17.2293 6.81266L15.396 8.65641L17.2293 10.5002L15.396 12.3439L17.2293 14.1877L20.9168 10.5002L17.2293 6.81266ZM6.81266 3.771L8.65641 5.60433L10.5002 3.771L12.3439 5.60433L14.1877 3.771L10.5002 0.0834961L6.81266 3.771Z",
    fill: "white",
    fillOpacity: 0.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 13.625C12.2259 13.625 13.625 12.2259 13.625 10.5C13.625 8.77411 12.2259 7.375 10.5 7.375C8.77411 7.375 7.375 8.77411 7.375 10.5C7.375 12.2259 8.77411 13.625 10.5 13.625Z",
    fill: "white",
    fillOpacity: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionControl);
export default __webpack_public_path__ + "static/media/actionControl.ff0692c51d655a34f650e93a91faa180.svg";
export { ForwardRef as ReactComponent };